import { ArrowRightLeft, Star } from "lucide-react";

import { Avatar } from "./Avatar";

const PITCH_ROWS = [
  ["ataque", "attack"],
  ["meio", "midfield"],
  ["defesa", "defense"],
  ["goleiro", "goal"],
];

function TeamPitchPlayer({ editable, onAdjust, player, user }) {
  return (
    <div className={`pitch-player ${player.line || "ataque"}`} data-testid={`team-player-${player.id}`}>
      <Avatar user={user || player} size="md" />
      <strong>{player.name?.split(" ")[0]}</strong>
      <small>
        <Star size={9} fill="currentColor" />
        {player.rating.toFixed(1)}
      </small>
      {editable && (
        <button className="adjust-player-button" onClick={onAdjust} aria-label={`Ajustar ${player.name}`} data-testid={`adjust-player-${player.id}`}>
          <ArrowRightLeft size={13} />
        </button>
      )}
    </div>
  );
}

export function TeamPitchList({ editable, lookup, onSelectPlayer, teams }) {
  return (
    <div className="team-pitch-list">
      {teams.map((team, index) => (
        <article className="pitch-team-card" key={team.name} data-testid={`team-card-${index}`}>
          <header style={{ borderLeftColor: team.color }}>
            <div>
              <span>{team.name.toUpperCase()}</span>
              <strong data-testid={`team-average-rating-${index}`}>
                {team.avg_rating.toFixed(1)}
                <small>★ média</small>
              </strong>
            </div>
            <b data-testid={`team-player-count-${index}`}>
              {team.players.length} jogadores
            </b>
          </header>
          <div className="team-pitch">
            {PITCH_ROWS.map(([line, className]) => (
              <div className={`pitch-row ${className}`} key={line}>
                {team.players.filter((player) => player.line === line).map((player) => (
                  <TeamPitchPlayer
                    editable={editable}
                    key={player.id}
                    onAdjust={() => onSelectPlayer(player.id)}
                    player={player}
                    user={lookup[player.id]}
                  />
                ))}
              </div>
            ))}
          </div>
        </article>
      ))}
    </div>
  );
}